import { Container } from 'inversify-props';

import setupContactPointsSowosModerate from './sowos-moderate/setup';

export default function setupInvestorGoalModule(container: Container) {
  setupContactPointsSowosModerate(container);
}
